import { Table, Tag } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import {
  questionnaireConfigSchema
} from 'data/questionnaire-config-type';
import { useMemo } from 'react';
import { ResponseColumn } from './components/column-questionnaire-response';
import { generateQuestionFilterColumnConfig } from './utils/generateQuestionFilterColumnConfig';
import { useProcessData } from './utils/hook-useProcessData';
import { InventoryTableDisplayProps } from './types';

export function InventoryTableDisplay(props: InventoryTableDisplayProps) {
  /**
   * Validate that the schema is correct
   */
  const parsedConfiguration = useMemo(
    () => questionnaireConfigSchema.parse(props.config),
    [props.config]
  );

  /**
   * Generate the table rows from the inventory data
   */
  const data = useProcessData(
    parsedConfiguration,
    props.inventory,
    props.inventoryFilterConfig
  );

  const columns = useMemo<ColumnsType<(typeof data)[number]>>(
    () => [
      {
        key: 'question',
        title: 'Question',
        dataIndex: 'question',
        width: '40%',
        ...generateQuestionFilterColumnConfig()
      },
      {
        key: 'Response',
        title: 'Response',
        dataIndex: 'response',
        render: ResponseColumn
      },
      {
        key: 'tags',
        title: 'Tags',
        hidden: true,
        render: (_val, record) =>
          record.tags.criticalItem && <Tag>Critical item</Tag>
      }
    ],
    []
  );

  return <Table columns={columns} dataSource={data} />;
}
